import React from "react";

function StopIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_289_12)">
        <rect x="4" y="4" width="17" height="17" rx="3" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_289_12">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default StopIcon;
